import React from "react";

const SessionExpired = () => { 
    return ( 
        <div style={{ textAlign:"center", marginTop:"100px"}} > 
            <h2> Session Expired </h2>
            <p> Your Session has expired due to inactivity </p>
            <button onClick={() => window.location.reload()}> Restart App </button>
        </div>
    )
    
}

export default SessionExpired;